import * as actions from 'actions';
import textEditingMaker from 'reducersMakers/textEditingMaker';

export default textEditingMaker({
  submitType: actions.CHAT_MESSAGE_ADD,
  submitSuccessType: actions.CHAT_MESSAGE_ADD,
  updateTextType: actions.CHAT_MESSAGE_EDITING_UPDATE_TEXT,
  resetType: actions.CHAT_MESSAGE_EDITING_RESET
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/textEditing/chatMessage/reducer.js
 **/